import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IContactInformation } from "./contactInformation.interfaces";

export const initialState: IContactInformation = {
  firstName: "",
  middleName: "",
  lastName: "",
  phoneNumber: null,
  email: "",
  genderType: "",
};

export const contactInformationSlice = createSlice({
  name: "contactInformation",
  initialState,
  reducers: {
    setFullContactInformationSlice: (
      state,
      action: PayloadAction<IContactInformation>,
    ) => {
      return action.payload;
    },
    resetContactInformation: (state) => {
      return initialState;
    },
  },
});

export const { setFullContactInformationSlice, resetContactInformation } =
  contactInformationSlice.actions;
